<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router';
    import fetchData from '../api.js';
    import { systemUrl } from '../api.js';
    import { sendPrintJob } from '../base/printer.js'; 
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Shipment from '../pages/Shipment.svelte';
    import Status from '../components/Status.svelte';
    import { createEventDispatcher } from 'svelte';
    

    export let orders = []; 

    let ordersList = orders;
    let statuses = [];
    let statusShow = false;


    const print_url = systemUrl + '/label?token=' + $UserStore.data + "&order_ids=";    


    const dispatch = createEventDispatcher();


    onMount(async() => {
    });

    $: ordersSelectedIds = orders
        .filter(order => order.enabled) 
        .map(order => order.order_id);

        
    const BulkShipment = () => {
        push('/shipments/' + ordersSelectedIds.join(","))
    }

    const BulkPrint = () => {

        //const printIds = orders.filter(order => order.enabled && order.shipment_id).map(order => order.order_id);
        const printIds = orders.filter(order => order.enabled).map(order => order.order_id);
        let link = print_url + printIds.join(",");
        if (shippingo=="1") {
            link += "&shippingo=1";
        }
        window.open(link, '_blank');

    }

    const BulkPacking = () => {
        push('/shipments/' + ordersSelectedIds.join(",") + "/likut")
    }

    const openStatusBox = (index) => {
        
        statusShow = true;
        statuses = orders[index].shipments_status_list

    }

    const closeStatus = async(event) => {
        statusShow = !statusShow;
    }

    let allChecked = false;

    function checkBoxAll() {
        // Toggle the state of `allChecked`
        allChecked = !allChecked;

        // Set each `enabled` property to match the `allChecked` state
        for (const key in orders) {
            orders[key].enabled = allChecked;
        }
    }

    

    
</script>
<Status {statuses} {statusShow} on:close={closeStatus} />
{#if ordersSelectedIds.length}
<div class="orders-bulk-con">
    <div class="button" on:click={()=> BulkShipment() }>{$_('orders.bulk_shipment')}</div>
    <div class="button" on:click={()=> BulkPrint() }>{$_('orders.bulk_print')}</div>
    <!-- <div class="button" on:click={()=> BulkPacking() }>{$_('orders.bulk_packing')}</div> -->
</div>
{/if}
<div class="table table-shipments orders">
    <div class="head">
        <div class="input_con radio checkbox">            
            <input id="id_all" type="checkbox" bind:checked={allChecked} on:click={checkBoxAll}>       
            <label for="id_all"><span></span></label>     
        </div>
        <div>{$_('orders.date')}</div>
        <div>{$_('orders.order_name')}</div>
        <div>{$_('orders.shipment_id')}</div>
        <div>{$_('orders.type')}</div>
        <div>{$_('orders.shipping_customer_details')}</div>
        <!-- <div>{$_('orders.address')}</div> -->
        <div>{$_('orders.phone')}</div>        
        <div>{$_('orders.shipping_method')}</div>
        <div>{$_('orders.shipment_status')}</div>        
        {#if $UserStore.id==2205}
        <div>{$_('orders.external_id')}</div>
        <div>{$_('orders.print_date')}</div>
        {/if}
        <div></div>
    </div>
    {#each orders as item,index}
    <div class="content">
        <div class="input_con radio checkbox">            
            <input id="enabled{index}" type="checkbox" bind:value={item.enabled} bind:checked={item.enabled}>       
            <label for="enabled{index}"><span></span></label>     
        </div>
        <div>
            <div class="mobile">{$_('orders.date')}</div>
            <div class="date_time"> 
                <div>{item.current_time }</div>
                <div class="date">{item.current_date }</div>                            
            </div>
        </div>
        <div>
            <div class="mobile">{$_('orders.order_name')}</div>
            <div>{item.order_name}</div>
        </div>
        <div class="shipment_id">
            <div class="mobile">{$_('orders.shipment_id')}</div>
            <div>
                {#if item.shipment_id!=null}
                <a href="{print_url}{item.order_id}" target="_blank">
                    <i class="fa-solid fa-print red-color"></i> 
                    <span>{item.shipment_id}</span>
                </a>
                {:else}
                <i class="fa-solid fa-circle-exclamation"></i>
                {/if}
            </div>
        </div>
        <div>
            <div class="mobile">{$_('orders.type')}</div>
            <div>{$_('orders.type' + item.type)}</div>
        </div>
        <div>
            <div class="mobile">{$_('orders.shipping_customer_details')}</div>            
            <div class="address text-right">
                <div><strong>{$_('orders.customer')}:</strong> {item.shipping_firstname}</div>
                <div><strong>{$_('orders.city')}:</strong> {item.shipping_city}</div>
                <div><strong>{$_('orders.address')}:</strong> {item.shipping_address}</div>
            </div>
        </div>
        <!-- <div>
            <div class="mobile">{$_('orders.address')}</div>
            <div class="address">
                <div>{item.shipping_city}</div>
                <div>{item.shipping_address}</div>
            </div>
        </div> -->
        <div>
            <div class="mobile">{$_('orders.phone')}</div>
            <div>
                <a class="phone" href="tel:{item.shipping_phone}"><i class="fa-solid fa-phone"></i></a>
                <a class="phone whatsapp" href="https://wa.me/{item.shipping_phone}"><i class="fa-brands fa-whatsapp"></i></a>
                <span class="ltr">{item.shipping_phone}</span>
            </div>
        </div>
        <div>
            <div class="mobile">{$_('orders.shipping_method')}</div>
            <div>
                <span class="ltr">{#if item.shipping_method!=null}{item.shipping_method}{/if}</span>
            </div>
        </div>
        <div>
            <div class="mobile">{$_('orders.shipment_status')}</div>
            <div>
                <div class="text-[12px]">
                    {#if Object.keys(item.shipment_status).length}
                        <div>{item.shipment_status.date}</div>
                        <div>{item.shipment_status.status}</div> 
                        <div on:click={()=>openStatusBox(index)} class="bg-red-100 hover:bg-red-300 text-black rounded-[15px] p-1 cursor-pointer">{$_('orders.view_all_status')}</div>                       
                    {/if}
                </div>
            </div>
        </div>
        
        {#if $UserStore.id==2205}
        <div>
            <div class="mobile">{$_('orders.verifone')}</div>
            <div>
                <span class="ltr">{#if item.external_id!=null}{item.external_id}{:else}<i class="fa-solid fa-circle-exclamation"></i>{/if}</span>
            </div>
        </div>
        <div class="size-12">
            <div class="mobile">{$_('orders.print_date')}</div>
            <div>
                <span class="ltr">{item.print_date}</span>
                <div class="pbutton" on:click={()=>  { sendPrintJob(item.order_id,2); }}>הדפסה</div>
            </div>
        </div>   
        {/if}     
        <div on:click={()=> push('/shipment/' + item.order_id)}>
         
            <div class="small_button">
                {#if item.shipment_id}
                <span>{$_('orders.edit_shipment')}</span>
                <i class="fa-solid fa-pen-to-square"></i>
                {:else}
                <span>{$_('orders.send_shipment')}</span>
                <i class="fa-solid fa-chevron-left"></i>
                {/if}
            </div>
            
        </div>
    </div>
    {/each}
</div>

<style>


.size-12 {
    font-size:12px;
}
.pbutton {
    color: var(--theme-one-color);
    cursor: pointer;
}
.table-shipments .content > div{
    vertical-align: middle;;
}
.table-shipments .content .red-color {
    color: var(--theme-one-color);
}
.table-shipments .content > div:nth-child(6) {
    max-width:150px;
}
.table-shipments .content .date_time {
    display: flex;
    flex-direction: column;
}
.date_time .date {
    font-size: 11px;;
}
a.phone { 
    display: inline-block;
    padding:0 2px;
    font-size: 14px;; 
    /* color: #050a30;   */
}
a.phone.whatsapp {
    text-decoration: none;
    color: green;  
    font-size: 17px;;  
}
.shipment_id {
   /* color: #050a30;    */
   cursor: pointer;
}
.shipment_id span {
    display: inline-block;
    padding:0 5px;
    /* text-decoration: underline; */
}

@media screen and (max-width:600px) {
    .table-shipments .content > div:nth-child(6) {
        max-width:none;
    }
    .shipment_id span {
        padding:0;
    }

    .address {
        text-align: left;
    }
}

</style>